module.exports = __webpack_public_path__ + "static/media/3.f05d2195.jpg";